import styled, { css } from "styled-components";

export const customImportanceStyles = {
  container: (provided) => ({
    ...provided,
    minWidth: "150px",
    flexShrink: 0,
    cursor: "pointer",
    height: "auto"
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "fit-content",
    height: "auto",
    border: "none",
    borderRadius: "5px",
    backgroundColor: "var(--primary-dark-50)",
    boxShadow: state.isFocused ? "0 0 0 1px var(--primary-dark-300)" : "none"
  }),
  valueContainer: (base) => ({ ...base, padding: "5px 8px" }),
  singleValue: (base) => ({
    ...base,
    color: "var(--primary-dark)",
    fontFamily: "Rubik",
    fontSize: "1rem",
    LineHeight: "17px",
    cursor: "pointer",
    fontWeight: 500,
    padding: "1px 0"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
    cursor: "pointer",
    color: "var(--primary-dark-300)",
    "&:hover": {
      color: "var(--primary-dark-400)"
    }
  }),
  menu: (provided) => ({
    ...provided,
    left: "50%",
    transform: "translateX(-50%)",
    width: "max-content",
    minWidth: "190px"
  }),
  menuList: (provided) => ({
    ...provided,
    borderRadius: "4px",
    backgroundColor: "var(--primary-dark)",
    padding: 0,
    minWidth: "100%",
    width: "max-content"
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    color: "var(--neutral-gray)",
    fontFamily: "Rubik",
    fontSize: "1rem",
    fontWeight: 500,
    height: "35px",
    display: "flex",
    alignItems: "center",
    width: "100%",

    ...(state.data.isShaded
      ? {
          backgroundColor: "var(--primary-dark-500)",
          padding: "5px 15px",
          borderBottom: "1px solid var(--primary-dark-400)",
          "&:hover": {
            backgroundColor: "var(--primary-dark-600)",
            color: "var(--neutral-gray-100)"
          }
        }
      : {
          backgroundColor: "var(--primary-dark)",
          padding: "5px 15px 5px 25px",
          borderBottom: "1px dashed var(--primary-dark-400)",
          "&:hover": {
            backgroundColor: "var(--primary-dark-600)",
            color: "var(--primary-white)"
          }
        })
  })
};

export const ReqCard = styled.div`
  transition: all 0.2s ease;

  ${({ $needsConfig }) =>
    $needsConfig &&
    css`
      border-radius: 6px;
      border: 3px solid var(--primary-blue);
      padding: 8px;
    `}
`;

export const AdjustTag = styled.div`
  padding: 4px 8px;
  width: fit-content;
  margin-bottom: 13px;
  border-radius: 3px;
  background-color: var(--primary-blue);

  color: var(--primary-white);
  text-align: center;
  font-family: Rubik;
  font-size: var(--fs-sm);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const RadioButton = styled.input`
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  pointer-events: none;
  appearance: none;
  border-radius: 50%;
  border: 1px solid #4e4f87;
  background-color: var(--primary-dark-500);
  position: relative;

  &:checked {
    background-color: var(--primary-white);
    border-color: var(--primary-dark-400);
  }

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: var(--primary-green);
    border: 1px solid #2ed487;
  }
`;

export const RequirementHeader = styled.div`
  display: flex;
  padding: 5px 10px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background-color: var(--primary-white);
  gap: 10px;
`;

export const RequirementInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`;

export const Info = styled.span`
  font-size: 1rem;
  line-height: 20px;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  color: var(--primary-dark);

  > span {
    color: var(--primary-dark-300);
  }
`;

export const Dropdown = styled.div`
  display: grid;
  place-items: center;
  cursor: pointer;
  flex-shrink: 0;

  > svg {
    transition: transform 0.3s ease;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const DotsBox = styled.div`
  background-color: transparent;
  border: none;
  color: var(--primary-dark);
  width: 20px;
  height: 20px;
  padding: 0;
  cursor: pointer;
  display: grid;
  place-items: center;
  flex-shrink: 0;
`;

export const MiniMenu = styled.ul`
  display: flex;
  width: 190px;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 4px;
  background-color: var(--primary-dark);
`;

export const MenuItem = styled.li`
  display: flex;
  height: 40px;
  padding: 11px 15px 12px 15px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  border-radius: inherit;
  border-bottom: 1px solid var(--primary-dark-400);
  background-color: var(--primary-dark);

  color: var(--neutral-gray);
  font-size: 1rem;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    background-color: var(--primary-dark-500);
  }
`;

export const Popover = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: row;

  padding: 10px 20px;
  border-radius: 4px;
  background-color: var(--primary-white);
  border: 1px solid var(--primary-dark);
`;

export const ToggleSwitch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  height: 26px;

  border-radius: 100px;
  background: var(--primary-dark-50);
  padding: 2px 3px;
  min-width: 0;

  > label[aria-label="automated-label"] {
    color: var(--primary-dark);
    font-family: Rubik;
    font-size: 0.857rem; // 12px
    font-style: normal;
    font-weight: 400;
    white-space: nowrap;
    line-height: normal;

    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 80px;
  }
`;

export const RobotIcon = styled.div`
  display: grid;
  place-content: center;

  flex-shrink: 0;
  width: 22px;
  height: 22px;
  background-color: var(--primary-dark-100);
  border-radius: 50%;

  font-size: 1rem;
`;
